import Gravity from 'Gravity';

import { searchResult } from './helpers/search-result';
import initHeader from './header';
import initCookieBar from './cookie-bar';
import { initContactUsLabelForm } from './contact-us-label-form';
import { initUTMTracking } from './utm-tracking';

// In this function you add all the code that needs to run after the document is ready
Gravity.ready(() => {
    searchResult();
    setTimeout(initHeader, 0);
    initCookieBar();
    initContactUsLabelForm();
    initUTMTracking();
});

// Code that doesn't need "document ready" goes here
Gravity.handleFirstTab();

// Global modules animation
Gravity.addInViewportClass('[data-animated-section="true"]', 'in-view', null, {rootMargin: '-15% 0px -15% 0px'});
